import { anodum, nanoid } from '@yola/ws-sdk';

function createCompositeGroup({
  aspectRatio = '1',
  slot = null,
  mediaGroupId = nanoid(6),
  className = null,
} = {}) {
  return anodum.parseElementFromString(`
    <ws-composite-group
      aspect-ratio="${aspectRatio}"
      ${slot ? `slot="${slot}"` : ''}
      ${className ? `class="${className}"` : ''}
      ${mediaGroupId ? `media-group-id="${mediaGroupId}"` : ''}
    ></ws-composite-group>
  `);
}

export default createCompositeGroup;
